module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [(_vm.loading) ? _c('div', [(_vm.active == 0) ? _c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '单位名称不能为空'
      }],
      "label": "单位名称",
      "input-align": "right",
      "error-message-align": "right",
      "left-icon": "question-o",
      "clearable": "",
      "placeholder": "请输入单位名称"
    },
    on: {
      "click-left-icon": function($event) {
        return _vm.onQuestion('danwei')
      }
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "radio",
      "label": "类型",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "horizontal"
          },
          model: {
            value: (_vm.formData.kaojitype),
            callback: function($$v) {
              _vm.$set(_vm.formData, "kaojitype", $$v)
            },
            expression: "formData.kaojitype"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "考级中心"
          }
        }, [_vm._v("考级中心")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "考级点"
          }
        }, [_vm._v("考级点")])], 1)]
      },
      proxy: true
    }], null, false, 4275042063)
  }), _vm._v(" "), (_vm.formData.kaojitype == '考级中心') ? _c('van-field', {
    attrs: {
      "name": "radio",
      "label": "考级中心类型",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          model: {
            value: (_vm.formData.kaoji_jiameng_type),
            callback: function($$v) {
              _vm.$set(_vm.formData, "kaoji_jiameng_type", $$v)
            },
            expression: "formData.kaoji_jiameng_type"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "5"
          }
        }, [_vm._v("样板考级中心（投入成本13.5万元）")])], 1)]
      },
      proxy: true
    }], null, false, 403530144)
  }) : _c('van-field', {
    attrs: {
      "name": "radio",
      "label": "考级点类型",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          model: {
            value: (_vm.formData.kaoji_jiameng_type),
            callback: function($$v) {
              _vm.$set(_vm.formData, "kaoji_jiameng_type", $$v)
            },
            expression: "formData.kaoji_jiameng_type"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "2"
          }
        }, [_vm._v("考级点（预备）（投入成本0元）")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "3"
          }
        }, [_vm._v("样板考级点（投入成本9800元）")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "7"
          }
        }, [_vm._v("街舞啦啦操考点")])], 1)]
      },
      proxy: true
    }], null, false, 805323252)
  }), _vm._v(" "), _c('van-cell', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.kaoji_jiameng_type > 2),
      expression: "formData.kaoji_jiameng_type>2"
    }],
    attrs: {
      "title": "协议下载/上传"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.kaoji_jiameng_type > 2),
      expression: "formData.kaoji_jiameng_type>2"
    }],
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.xieyipic,
      "limit": 20,
      "name": 'xieyipic'
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.kaoji_jiameng_type > 2),
      expression: "formData.kaoji_jiameng_type>2"
    }],
    staticClass: "operate-desc-left",
    staticStyle: {
      "color": "#1989fa"
    },
    on: {
      "click": function($event) {
        return _vm.xieyiDownload()
      }
    }
  }, [_vm._v("请先点击这里下载《协议模版》打印盖章后拍照上传协议照片")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "单位执照",
      "value": _vm.formData.zhizhaopic.length + '/1'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.zhizhaopic,
      "limit": 1,
      "name": 'zhizhaopic'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("上传营业执照 或 法人证书 或 组织结构代码证")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "场地面积",
      "rules": [{
        required: true,
        message: '场地面积不能为空'
      }],
      "error-message-align": "right",
      "type": "number",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入场地面积（平米）"
    },
    model: {
      value: (_vm.formData.chandimianji),
      callback: function($$v) {
        _vm.$set(_vm.formData, "chandimianji", $$v)
      },
      expression: "formData.chandimianji"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '人数不能为空'
      }],
      "error-message-align": "right",
      "label": "人数",
      "type": "number",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入人数"
    },
    model: {
      value: (_vm.formData.yundongyuanrenshu),
      callback: function($$v) {
        _vm.$set(_vm.formData, "yundongyuanrenshu", $$v)
      },
      expression: "formData.yundongyuanrenshu"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county,
      "input-align": "right",
      "label": "地区选择",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入详细地址'
      }],
      "error-message-align": "right",
      "label": "详细地址",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "场地照片",
      "value": _vm.formData.changdipic.length + '/5'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.changdipic,
      "limit": 5,
      "name": 'changdipic'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("上传5张场地照片")])], 1), _vm._v(" "), _c('van-divider', [_vm._v("负责人信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入姓名'
      }],
      "error-message-align": "right",
      "label": "姓名",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "nickname", $$v)
      },
      expression: "formData.nickname"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.idCard,
        message: '请输入正确的身份证号'
      }],
      "error-message-align": "right",
      "label": "身份证号",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.certificatenumber),
      callback: function($$v) {
        _vm.$set(_vm.formData, "certificatenumber", $$v)
      },
      expression: "formData.certificatenumber"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.phone,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "label": "手机",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入手机"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("日常联系人信息\n        ")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入姓名'
      }],
      "error-message-align": "right",
      "label": "姓名",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.contactsname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contactsname", $$v)
      },
      expression: "formData.contactsname"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.idCard,
        message: '请输入正确的身份证号'
      }],
      "error-message-align": "right",
      "label": "身份证号",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.contactscertificatenumber),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contactscertificatenumber", $$v)
      },
      expression: "formData.contactscertificatenumber"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.email,
        message: '请输入正确的邮箱'
      }],
      "error-message-align": "right",
      "label": "邮箱",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入邮箱"
    },
    model: {
      value: (_vm.formData.contactsemail),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contactsemail", $$v)
      },
      expression: "formData.contactsemail"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.phone,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "label": "手机",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入手机"
    },
    model: {
      value: (_vm.formData.contactsphone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contactsphone", $$v)
      },
      expression: "formData.contactsphone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "验证码",
      "rules": [{
        required: true,
        message: '请输入验证码'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入验证码"
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function() {
        return [_c('van-button', {
          attrs: {
            "native-type": "button",
            "size": "small",
            "type": "primary",
            "disabled": _vm.clockSecond > 0
          },
          on: {
            "click": _vm.getCode
          }
        }, [_vm._v(_vm._s(_vm.clockSecond > 0 ?
          '(' + _vm.clockSecond + 's)' : '获取验证码'))])]
      },
      proxy: true
    }], null, false, 3177600067),
    model: {
      value: (_vm.formData.phonecode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phonecode", $$v)
      },
      expression: "formData.phonecode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n            提交申请\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.active == 1 || _vm.active == 2) ? _c('div', {
    staticClass: "step-three"
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmitThree,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('div', {
    staticClass: "step-three-title"
  }, [_vm._v("确认验收信息")]), _vm._v(" "), _c('div', {
    staticClass: "step-three-content"
  }, [_c('div', [_vm._v("请确认您的创建清单：")]), _vm._v(" "), _c('div', {
    staticClass: "step-three-danwei"
  }, [_vm._v(_vm._s(_vm.formData.danwei) + " （" + _vm._s(_vm.formData.kaojitype) + "）")]), _vm._v(" "), (_vm.formData.kaoji_jiameng_type == 2) ? _c('div', {
    staticClass: "step-three-danwei"
  }, [_vm._v("0元")]) : (_vm.formData.kaoji_jiameng_type == 3) ? _c('div', {
    staticClass: "step-three-danwei"
  }, [_vm._v("9800元")]) : (_vm.formData.kaoji_jiameng_type == 4) ? _c('div', {
    staticClass: "step-three-danwei"
  }, [_vm._v("12万元")]) : (_vm.formData.kaoji_jiameng_type == 5) ? _c('div', {
    staticClass: "step-three-danwei"
  }, [_vm._v("13.5万元")]) : _vm._e()]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "请下载文化布置，发至广告公司制作"
    }
  }), _vm._v(" "), (_vm.formData.kaojitype == '考级点') ? _c('div', {
    staticClass: "dialog-step-li"
  }, [_c('div', {
    staticClass: "dialog-step-li-text",
    on: {
      "click": function($event) {
        return _vm.download({
          name: '新七彩星级文化包',
          url: 'https://ccago.oss-cn-hangzhou.aliyuncs.com/newqicaixingjiwenhuabao.rar'
        })
      }
    }
  }, [_vm._v("\n                考级点文化包（兼容版）请下载制作\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.formData.kaojitype == '考级中心') ? _c('div', {
    staticClass: "dialog-step-li"
  }, [_c('div', {
    staticClass: "dialog-step-li-text",
    on: {
      "click": function($event) {
        return _vm.download({
          name: '新七彩星级文化包',
          url: 'https://ccago.oss-cn-hangzhou.aliyuncs.com/newqicaixingjiwenhuabao.rar'
        })
      }
    }
  }, [_vm._v("\n                考级中心文化包（兼容版）请下载制作\n              ")])]) : _vm._e(), _vm._v(" "), _c('van-cell', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUpload),
      expression: "showUpload"
    }],
    attrs: {
      "title": "请上传现场文化布置图"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUpload),
      expression: "showUpload"
    }],
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.kaoji_yanshoufile,
      "limit": 5,
      "name": 'kaoji_yanshoufile'
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "native-type": "submit",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.onPay
    }
  }, [_vm._v("\n              我要付款\n            ")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n              完成申报\n            ")])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "收款账户",
      "show-confirm-button": false,
      "close-on-click-overlay": true
    },
    model: {
      value: (_vm.showPay),
      callback: function($$v) {
        _vm.showPay = $$v
      },
      expression: "showPay"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "80%",
      "text-align": "center",
      "margin": "0px auto 20px",
      "font-size": "14px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1625623675743-3.jpeg"
    }
  }), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.onPayDownload
    }
  }, [_vm._v("下载二维码\n        ")])], 1)]), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "联系人信息",
      "show-cancel-button": false,
      "close-on-click-overlay": true
    },
    on: {
      "close": _vm.onContactClose
    },
    model: {
      value: (_vm.contactShow),
      callback: function($$v) {
        _vm.contactShow = $$v
      },
      expression: "contactShow"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "80%",
      "margin": "0px auto 20px"
    }
  }, [_c('div', [_vm._v("姓名：" + _vm._s(_vm.contactRow.name))]), _vm._v(" "), _c('div', [_vm._v("电话："), _c('a', {
    staticStyle: {
      "color": "#409eff"
    },
    attrs: {
      "href": 'tel:' + _vm.contactRow.phone
    }
  }, [_vm._v(_vm._s(_vm.contactRow.phone))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59905de8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/StationApplyMine.vue
// module id = 2411
// module chunks = 0